import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Github, Heart } from 'lucide-react';

export const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer id="footer" className="bg-rs-bg border-t border-rs-dark py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0 text-center md:text-left rtl:md:text-right">
            <h2 className="text-2xl font-bold text-rs-bright tracking-widest">RED SHADOWS | RS</h2>
            <p className="text-gray-300 text-sm mt-1">
              &copy; 2021 - {new Date().getFullYear()} {t('footer.rights')}
            </p>
          </div>
          <div className="flex space-x-6 rtl:space-x-reverse">
            <a
              href="https://github.com/red-shadows-rs"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-rs-bright transition-colors"
              aria-label="GitHub"
            >
              <Github size={20} />
            </a>
          </div>
        </div>
        <div className="mt-8 text-center text-xs text-gray-400 flex items-center justify-center gap-1">
          <span>{t('footer.madeWith')}</span>{' '}
          <Heart size={12} className="text-rs-muted" fill="#be2041" />{' '}
          <span>{t('footer.byTeam')}</span>
        </div>
      </div>
    </footer>
  );
};
